




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
  import { mapState } from 'vuex'
  import { required, requiredIf, numeric, minLength, maxLength, minValue, maxValue,helpers } from 'vuelidate/lib/validators'
  import moment from 'moment'
  import { BTabs, BTab, BFormDatepicker, BFormInput } from 'bootstrap-vue'
  import { VueEditor } from 'vue2-editor'
  import VueSelect from 'vue-select'
  import ModalHeader from '@/components/ModalHeader.vue'
  import PatientSearch from '@/components/PatientSearch.vue'
  import InputPopover from '@/components/InputPopover.vue'
  import { Form, FormQuestion, GapPatientFilter, ScheduleAppointment, GapLogEntry } from '@/store/modules/types'
  import { ScheduleType, ScheduleSession, SchedulePreReqType, GapLogType } from '@/store/modules/enums'
  import { fileIsImage, fileSize, fileIcon } from '@/utils'
  import FormWizard from '@/components/FormWizard.vue'
  import FormViewer from '@/components/FormViewer.vue'
  import FormViewerPdf from '@/components/FormViewerPdf.vue'
  import MultiAppointmentConflictModal from '@/components/schedule/MultiAppointmentConflictModal.vue'
  import jsPDF from 'jspdf'
  import html2canvas from 'html2canvas'
  import Swal from 'sweetalert2'

  const digitsOnly = value => (value || "").replace(/\D/g, "");

const phoneValidator = helpers.withParams(
  { type: "phoneValidator" },
  value => {
    if (!value) return true; // si el campo no es requerido
    return digitsOnly(value).length === 10;
  }
);

  @Component({
    components: {
      ModalHeader,
      BTabs,
      BTab,
      BFormDatepicker,
      BFormInput,
      VueSelect,
      VueEditor,
      PatientSearch,
      InputPopover,
      FormWizard,
      FormViewer,
      FormViewerPdf,
      MultiAppointmentConflictModal
    },
    computed: {
      ...mapState('auth', ['user', 'entityId']),
      ...mapState('schedule', ['calendars', 'typeStatus'])
    },
    validations: {
      appt: {
        main: {
          calendarId: {
            required
          },
          reasonId: {
            required
          },
          typeId: {
            required
          },
          date: {
            required
          },
          patient: {
            firstName: {
              required
            },
            lastName: {
              required
            },
            birth: {
              year: {
                //required,
                required: requiredIf(model => {
                  return model.day !== '' || model.month !== ''
                }),
                numeric
              },
              month: {
                //required,
                required: requiredIf(model => {
                  return model.year !== '' || model.day !== ''
                }),
                numeric,
                minValue: minValue(0),
                maxValue: maxValue(11)
              },
              day: {
                //required,
                required: requiredIf(model => {
                  return model.year !== '' && model.month !== ''
                }),
                numeric,
                minValue: minValue(1),
                maxValue: maxValue(31)
              }
            }/* ,
            phone: {
              required,
              numeric,
              minLength: minLength(10)
            } */
           ,
            phone: {
              required,
              phoneValidator
            }
          },
          lang: {
            required
          },
          statusId: {
            required
          }
        },
        service: {
          description: {
            required
          },
          address: {
            line1: {
              required
            },
            city: {
              required
            },
            state: {
              required,
              minLength: minLength(2),
              maxLength: maxLength(2)
            },
            zip: {
              required,
              minLength: minLength(5),
              maxLength: maxLength(10)
            },
            countryId: {
              required,
              minLength: minLength(2),
              maxLength: maxLength(2)
            }
          }
        }
      }
    }
  })
  export default class ApptEditor extends Vue {
    @Prop(Number) readonly apptId!: number
    @Prop(Number) readonly patientId!: number
    @Prop(String) readonly patientName!: string
    @Prop(String) readonly patientPhone!: string
    @Prop(String) readonly transportation!: string
    @Prop(Boolean) readonly officeCall!: boolean
    @Prop(Number) readonly gapId!: number
    entityId!: number
    record!: ''
    calendars!: Array<any>
    typeStatus!: Array<any>
    reasons = Array<any>()
    priorities = Array<any>()
    insurers = Array<any>()
    links = Array<any>()
    calendar = {
      format: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        weekday: 'short'
      },
      minDate: new Date(),
      dates: Array<any>(),
      times: Array<any>(),
      fullDates: Array<string>()
    }
    quill = {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }]
      ]
    }
    appt: ScheduleAppointment = {
      id: null,
      recordDate: null,
      main: {
        calendarId: '',
        reasonId: '',
        priorityId: '',
        typeId: 'APT',
        date: moment().format('YYYY-MM-DD'),
        time: '',
        sessionId: '',
        patient: {
          id: null,
          firstName: '',
          lastName: '',
          lastName2: '',
          birth: {
            year: '',
            years: [],
            month: '',
            monthDays: [],
            day: '',
            date: ''
          },
          phone: '',
          insurer: {
            id: '',
            memberId: ''
          },
          EMR_ID: '',
          email: ''
        },
        lang: '',
        statusId: '2',
        transportation: null,
        archived: false,
        entityIsIntegrated: false,
        officeCall: false,
        hasTeleconferencing: false,
        duration: 0,
        reference: null
      },
      service: {
        description: '',
        address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip: '',
          countryId: ''
        }
      },
      prereqs: {
        list: [],
        selected: null
      },
      files: [],
      comment: '',
      recurrence: {
        enabled: false,
        frequency: 'WEEKLY',
        days: [],
        count: 2
      }
    }
    prereqForm = {
      form: {} as Form,
      questions: Array<FormQuestion>()
    }

    weekDays = [
      { label: 'MO', value: 'MON' },
      { label: 'TU', value: 'TUE' },
      { label: 'WE', value: 'WED' },
      { label: 'TH', value: 'THU' },
      { label: 'FR', value: 'FRI' },
      { label: 'SA', value: 'SAT' },
      { label: 'SU', value: 'SUN' }
    ]

    showConflictModal = false
    bulkValidationResult: any = null
    bulkConflictResult: any = null

    @Watch('appt.main.calendarId')
    onCalendarChanged(id: string) {
      if (id) {
        this.getReasons(id)
        this.getPriorities(id)
        this.getDates(id)
        this.getFullDates(id)
        this.setApptDuration()
        this.getTimes()
        //if(!this.appt.main.lang)
        if (!this.appt.id) var calendar = this.calendars.filter(calendar => calendar.id == id)[0]

        if (!this.appt.id && calendar.defaultReasonId) {
          this.appt.main.reasonId = calendar.defaultReasonId
        }

        if (!this.appt.id && calendar.defaultStatusId) {
          this.appt.main.statusId = calendar.defaultStatusId
        }

        this.appt.main.lang = calendar.lang

        var insurersByEntity = calendar.insurersByEntity

        if (insurersByEntity) {
          this.getInsurers()
        } else {
          this.getInsurers(id)
        }

        this.getPreReqs()
      } else this.reasons = []
    }
    @Watch('appt.main.reasonId')
    onReasonChanged(id: number) {
      if (id) {
        const reason = this.reasons.find(r => r.id === id)
        if (reason) {
          this.appt.main.typeId = reason.apptTypeId
          this.appt.main.hasTeleconferencing = reason.hasTeleconferencing
          this.setApptDuration()

          var calendar = this.calendars.filter(calendar => calendar.id == id)[0]

          var cDefaultStatusId = calendar.defaultStatusId

          if (!this.appt.id && reason.defaultStatusId && !cDefaultStatusId) {
            this.appt.main.statusId = reason.defaultStatusId
          }
        }
      } else {
        this.appt.main.typeId = 'APT'
        this.appt.main.hasTeleconferencing = false
      }
      this.getPreReqs()
    }
    @Watch('appt.main.patient.birth', { deep: true })
    onBirthChanged(birth) {
      const birthdate = this.$moment([birth.year, birth.month, birth.day])
      this.appt.main.patient.birth.date = birthdate.isValid() ? birthdate.format('YYYY-MM-DD') : ''
    }
    typeChanged(e) {
      this.appt.main.statusId = '2'
    }
    setPatient(patient, phoneType, phone) {
      // SET PATIENT
      const p = this.appt.main.patient
      p.id = patient.id
      p.firstName = patient.firstName
      p.lastName = patient.lastName
      p.lastName2 = patient.lastName2
      // BIRTH
      const birthdate = moment(patient.birthdate)
      p.birth.year = birthdate.year().toString()
      p.birth.month = birthdate.month().toString()
      this.setBirthMonthDays()
      p.birth.day = birthdate.date().toString()
      //
      p.phone = phone
      // CHECK INSURER
      const insurer = patient.insurerId && this.insurers.find(i => i.id === patient.insurerId)
      if (insurer) {
        p.insurer.id = patient.insurerId
      }
      p.insurer.memberId = patient.insurerMemberId
      // SET SERVICE ADDRESS
      const s = this.appt.service
      s.address.line1 = patient.addressLine1
      s.address.line2 = patient.addressLine2
      s.address.city = patient.city
      s.address.state = patient.state
      s.address.zip = patient.zip
      s.address.countryId = patient.countryId
      // SET LANG
      if (patient.lang) this.appt.main.lang = patient.lang
      //
    }
    setBirthMonthDays() {
      this.appt.main.patient.birth.monthDays = []
      const { year, month } = this.appt.main.patient.birth
      if (year === '' || month === '') {
        return
      }
      const days = this.$moment([year, month]).daysInMonth()
      for (let i = 1; i <= days; i++) {
        this.appt.main.patient.birth.monthDays.push(i.toString())
      }
    }
    setApptDuration() {
      var reasonDuration = this.reasons.filter(r => r.id == this.appt.main.reasonId)[0]?.apptDuration
      var calendarDuration = this.calendars.filter(c => c.id == this.appt.main.calendarId)[0]?.timeInterval

      if (!this.appt.id) {
        this.appt.main.duration =
          this.reasons && reasonDuration
            ? reasonDuration
            : calendarDuration
            ? calendarDuration
            : this.appt.main.duration
      }
    }
    setBirthYears() {
      let year = this.$moment().year() - 115
      while (year <= this.$moment().year()) {
        this.appt.main.patient.birth.years.push(year.toString())
        year++
      }
    }
    prereqIcon(typeId: string) {
      switch (typeId) {
        case SchedulePreReqType.FILE:
          return 'far fa-file-alt'
        case SchedulePreReqType.INFO:
          return 'fas fa-info-circle'
        case SchedulePreReqType.PICTURE:
          return 'far fa-file-image'
        case SchedulePreReqType.FORM:
          return 'far fa-file-alt'
      }
    }
    clearPreReq(req) {
      this.$modal.show('dialog', {
        title: `Remove prerequisite '${req.name}'`,
        text: 'Are you sure?',
        buttons: [
          {
            title: 'Yes',
            handler: () => {
              req.fileId = null
              req.fileName = null
              req.fileSize = null
              req.fileKey = null
              req.value = null
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'No',
            default: true
          }
        ]
      })
    }
    isDisabledDate(ymd: string, date: Date) {
      if (this.calendar.dates.length) {
        const weekday = moment(date)
          .format('ddd')
          .toUpperCase()
        let disabled = true
        this.calendar.dates.forEach(item => {
          if (item.date === '1900-01-01' && item.weekday === weekday) {
            disabled = item.disabled
          } else if (item.date === ymd) {
            disabled = item.disabled
          }
        })
        return disabled
      } else {
        return false
      }
    }
    getDateClass(ymd: string, date: Date) {
      if (this.calendar.fullDates.includes(ymd)) {
        return 'full-date'
      }
      return null
    }
    async getReasons(calendarId: string) {
      try {
        this.reasons = await this.$store.dispatch('schedule/getCalendarReasons', calendarId)
        if (!this.apptId) {
          const defaultReason = this.reasons.find(r => r.isDefault)
          if (defaultReason) {
            this.appt.main.reasonId = defaultReason.id
          } else {
            this.getPreReqs()
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    async getPriorities(calendarId: string) {
      try {
        this.priorities = await this.$store.dispatch('schedule/getCalendarPriorities', calendarId)
        if (!this.appt.id) {
          if (!this.priorities.length) {
            this.appt.main.priorityId = ''
          } else {
            this.appt.main.priorityId = this.priorities.filter(p => p.isDefault)[0]['id']
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    async getDates(calendarId: string) {
      try {
        this.calendar.dates = await this.$store.dispatch('schedule/getCalendarDates', calendarId)
      } catch (error) {
        console.log(error)
      }
    }
    async getFullDates(calendarId: string) {
      try {
        const data = await this.$store.dispatch('schedule/getCalendarFullDates', calendarId)
        this.calendar.fullDates = data.map(item => item.date)
      } catch (error) {
        console.log(error)
      }
    }
    async getTimes() {
      try {
        const { calendarId, date } = this.appt.main
        const times = await this.$store.dispatch('schedule/getCalendarTimes', {
          calendarId,
          date
        })
        if (times.length) {
          this.calendar.times = times
        } else {
          await this.setTimes()
        }
      } catch (error) {
        console.log(error)
      }
    }
    async setTimes() {
      const { calendarId } = this.appt.main
      const start = this.$moment('06:00', 'HH:mm:ss')
      const end = this.$moment('20:00', 'HH:mm:ss')
      let interval = 15
      if (calendarId) {
        const calendar = this.calendars.find(c => c.id === calendarId)
        if (calendar && parseInt(calendar.timeInterval)) {
          interval = parseInt(calendar.timeInterval)
        }
      }
      this.calendar.times = []
      while (start.isBefore(end)) {
        this.calendar.times.push({
          apptCount: 0,
          apptLimit: 0,
          disabled: false,
          sessionLimit: 0,
          time: start.format('HH:mm:ss')
        })
        start.add(interval, 'm')
      }
    }
    async getInsurers(calendarId?: any) {
      try {
        if (calendarId) {
          this.insurers = await this.$store.dispatch('schedule/getCalendarInsurers', calendarId)
          return
        }

        this.insurers = await this.$store.dispatch('schedule/getEntityInsurers', this.entityId)
      } catch (error) {
        console.log(error)
      }
    }
    async getAppt() {
      this.$store.commit('main/SET_LOADING', true)
      try {
        // GET APPT INFO
        const data = await this.$store.dispatch('schedule/getApptRecord', this.apptId)
        const { appt } = this
        appt.id = data.id
        appt.recordDate = data.recordDate
        appt.main.calendarId = data.calendarId
        appt.main.reasonId = data.reasonId
        appt.main.priorityId = data.priorityId
        appt.main.typeId = data.typeId
        appt.main.date = data.date
        appt.main.time = data.time
        appt.main.sessionId = data.sessionId
        appt.main.patient.id = data.patientId
        appt.main.patient.firstName = data.firstName
        appt.main.patient.lastName = data.lastName
        appt.main.patient.lastName2 = data.lastName2
        appt.main.patient.phone = data.phone
        appt.main.patient.email = data.email
        appt.main.patient.insurer.id = data.insurerId
        appt.main.patient.insurer.memberId = data.insurerMemberId
        this.record = data.PATIENT_EMR_ID ? data.PATIENT_EMR_ID : ''
        appt.main.patient.EMR_ID = this.record
        appt.main.lang = data.lang
        appt.main.statusId = data.statusId
        appt.main.transportation = data.transportation
        appt.main.archived = data.archived
        appt.main.entityIsIntegrated = data.entityIsIntegrated
        appt.main.reference = data.reference
        appt.main.duration = data.duration
        appt.comment = data.comment
        appt.main.hasTeleconferencing = data.hasTeleconferencing

        // BIRTH
        if (data.birthdate) {
          const birthdate = moment(data.birthdate)
          appt.main.patient.birth.year = birthdate.year().toString()
          appt.main.patient.birth.month = birthdate.month().toString()
          this.setBirthMonthDays()
          appt.main.patient.birth.day = birthdate.date().toString()
        }
        // SERVICE
        appt.service.description = data.serviceDescription
        if (data.serviceAddress) {
          appt.service.address = JSON.parse(data.serviceAddress)
        }
        // GET TIMES
        this.getTimes()
        // GET ATTACHMENTS
        this.getFiles()
        // GET LINKS
        this.getLinks()
        //
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }
    async getPreReqs() {
      const calendarId = this.appt.main.calendarId
      const apptTypeId = this.appt.main.typeId
      const apptId = this.appt.id
      try {
        this.appt.prereqs.list = await this.$store.dispatch('schedule/getApptPreReqList', {
          calendarId,
          apptTypeId,
          apptId
        })
      } catch (error) {
        console.log(error)
      }
    }
    async getPatient() {
      try {
        const filter: GapPatientFilter = {
          id: this.patientId.toString(),
          firstName: '',
          lastName: '',
          insurerMemberId: '',
          EMR_ID: '',
          birthdateFrom: null,
          birthdateTo: null,
          city: '',
          gender: '',
          phone: '',
          insurerList: [],
          ipaList: []
        }
        const patients = await this.$store.dispatch('gaps/getPatients', filter)
        const patient = patients[0]
        const phoneType = patient.mobilePhone
          ? 'M'
          : patient.homePhone
          ? 'H'
          : patient.otherPhone
          ? 'O'
          : patient.otherPhone2
          ? 'O'
          : ''
        const phone = patient.mobilePhone || patient.homePhone || patient.otherPhone || patient.otherPhone2 || ''
        this.setPatient(patient, phoneType, phone)
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }
    async getFiles() {
      try {
        this.appt.files = await this.$store.dispatch('schedule/getApptFileList', this.apptId)
      } catch (error) {
        console.log(error)
      }
    }
    async getLinks() {
      try {
        this.links = await this.$store.dispatch('schedule/getLinks', this.apptId)
      } catch (error) {
        console.log(error)
      }
    }

    // Método para alternar la selección de días
    toggleDay(dayValue: string) {
      const days = this.appt.recurrence?.days

      if (!days) return

      const index = days.indexOf(dayValue)

      if (index > -1) {
        days.splice(index, 1)
      } else {
        days.push(dayValue)
      }
    }

    // Resumen dinámico
    get recurrenceSummary() {
      if (!this.appt.recurrence?.enabled) return ''

      const freqMap = { DAILY: 'day', WEEKDAYS: 'day of week', WEEKLY: 'week', MONTHLY: 'month' }
      let summary = `Creating ${this.appt.recurrence.count} total appointments, one every ${
        freqMap[this.appt.recurrence.frequency]
      }.`

      if (this.appt.recurrence.frequency === 'WEEKDAYS') {
        if (this.appt.recurrence.days.length === 0) return 'Please select at least one day.'
        summary += ` Scheduled on: ${this.appt.recurrence.days.join(', ')}.`
      }

      return summary
    }

    generateRecurrenceList() {
      const { recurrence } = this.appt
      const { date, time } = this.appt.main

      // 1. Verificación de seguridad
      if (!recurrence || !recurrence.enabled) {
        return [{ date, time }]
      }

      const list: Array<{ date: string; time: string }> = []
      const count = parseInt(recurrence.count.toString())
      const frequency = recurrence.frequency // 'DAILY', 'WEEKLY', 'MONTHLY', 'WEEKDAYS'

      // Empezamos desde la fecha seleccionada originalmente
      let currentDate = this.$moment(date)
      const safetyLimit = this.$moment(date).add(2, 'years')

      while (list.length < count) {
        // 2. Validar disponibilidad del proveedor (this.calendar.dates)
        if (this.isProviderAvailable(currentDate)) {
          list.push({
            date: currentDate.format('YYYY-MM-DD'),
            time
          })
        }

        // 3. Lógica de incremento según frecuencia
        if (frequency === 'DAILY') {
          currentDate.add(1, 'days')
        } else if (frequency === 'WEEKLY') {
          // Salto de semana completa (mismo día de la semana)
          currentDate.add(1, 'weeks')
        } else if (frequency === 'WEEKDAYS') {
          // Avanza al siguiente día y busca coincidencia en los días seleccionados
          currentDate.add(1, 'days')
          if (recurrence.days && recurrence.days.length > 0) {
            let attempts = 0
            // Busca en los próximos 7 días hasta encontrar uno de los seleccionados
            while (!recurrence.days.includes(currentDate.format('ddd').toUpperCase()) && attempts < 7) {
              currentDate.add(1, 'days')
              attempts++
            }
          }
        } else if (frequency === 'MONTHLY') {
          currentDate.add(1, 'months')
        }

        // 4. Salida de emergencia para evitar bucles infinitos
        if (currentDate.isAfter(safetyLimit)) break
      }

      return list
    }

    generateRecurrenceListBK() {
      const { recurrence } = this.appt
      const { date, time } = this.appt.main

      // Si no está habilitado, retornamos solo la fecha principal
      if ((recurrence && !recurrence.enabled) || !recurrence) {
        return [{ date, time }]
      }

      const list: Array<{ date: string; time: string }> = []
      const count = parseInt(recurrence.count.toString())
      const frequency = recurrence.frequency // 'DAILY', 'WEEKLY', 'MONTHLY', 'WEEKDAYS'

      // Empezamos desde la fecha seleccionada
      let currentDate = this.$moment(date)

      // La primera cita (la actual) siempre cuenta como la #1
      // Si quieres que las 10 citas sean ADICIONALES a la de hoy, cambia la lógica del loop
      while (list.length < count) {
        // Validar si el proveedor trabaja en esta fecha/día
        if (this.isProviderAvailable(currentDate)) {
          list.push({
            date: currentDate.format('YYYY-MM-DD'),
            time
          })
        }

        // Saltar a la siguiente fecha según frecuencia
        if (frequency === 'DAILY') {
          currentDate.add(1, 'days')
        } else if (frequency === 'WEEKLY' || frequency === 'WEEKDAYS') {
          // En semanal, avanzamos día a día para encontrar el próximo día habilitado en el array days[]
          currentDate.add(1, 'days')

          // Si es WEEKDAYS/WEEKLY y se seleccionaron días específicos (ej: Mon, Fri)
          // Buscamos el siguiente día que esté en la lista de seleccionados
          if (recurrence.days.length > 0) {
            while (!recurrence.days.includes(currentDate.format('ddd').toUpperCase())) {
              currentDate.add(1, 'days')
            }
          }
        } else if (frequency === 'MONTHLY') {
          currentDate.add(1, 'months')
        }

        // Seguridad: Si buscamos por 2 años y no encontramos disponibilidad, romper loop
        if (currentDate.isAfter(this.$moment(date).add(2, 'years'))) break
      }

      return list
    }

    /**
     * Valida si el proveedor labora en una fecha específica
     * basándose en this.calendar.dates
     */
    isProviderAvailable(momentDate: any) {
      const ymd = momentDate.format('YYYY-MM-DD')
      const weekday = momentDate.format('ddd').toUpperCase() // "MON", "TUE", etc.

      return this.calendar.dates.some(item => {
        if (item.date === '1900-01-01') {
          // Si es 1900, trabaja por día de semana
          return item.weekday === weekday
        } else {
          // De lo contrario, trabaja por fecha específica
          return item.date === ymd
        }
      })
    }
    //

    async fileView(file) {
      this.$store.commit('main/SET_LOADING', true)
      try {
        await this.$store.dispatch('schedule/viewFile', file)
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }
    async fileDownload(fileKey: string) {
      this.$store.commit('main/SET_LOADING', true)
      try {
        await this.$store.dispatch('schedule/downloadFile', fileKey)
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }
    async uploadFile() {
      this.$store.commit('main/SET_LOADING', true)
      try {
        const file = this.fileInput.files![0]
        const fileKeys = await this.$store.dispatch('schedule/uploadFile', file)
        const fileKey = fileKeys[0]
        let fileId = null
        if (this.appt.id) {
          const data = await this.$store.dispatch('schedule/saveApptFile', {
            id: this.appt.id,
            key: fileKey
          })
          fileId = data.fileId
        }
        this.appt.files.push({
          id: fileId,
          key: fileKey,
          name: file.name,
          size: file.size
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }
    async uploadPreReqFile() {
      this.$store.commit('main/SET_LOADING', true)
      try {
        const { selected } = this.appt.prereqs
        const file = this.prereqFileInput.files![0]
        if (selected.typeId === SchedulePreReqType.PICTURE && !fileIsImage(file.name)) {
          this.$modal.show('dialog', {
            title: 'WaitingMed',
            text: 'File is not an image.'
          })
          return
        }
        const fileKeys = await this.$store.dispatch('schedule/uploadFile', file)
        const fileKey = fileKeys[0]
        selected.fileName = file.name
        selected.fileSize = file.size
        selected.fileKey = fileKey
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }
    async archiveFile(file) {
      if (file.id) {
        this.$modal.show('dialog', {
          title: 'Remove ' + file.name,
          text: 'Are you sure?',
          buttons: [
            {
              title: 'Yes',
              handler: async () => {
                this.$store.commit('main/SET_LOADING', true)
                try {
                  const { id } = this.appt
                  const fileId = file.id
                  await this.$store.dispatch('schedule/archiveApptFile', {
                    id,
                    fileId
                  })
                  this.$modal.hide('dialog')
                  this.getFiles()
                } catch (error) {
                  console.log(error)
                } finally {
                  this.$store.commit('main/SET_LOADING', false)
                }
              }
            },
            {
              title: 'No',
              default: true
            }
          ]
        })
      }
    }
    async sendCall() {
      this.$store.commit('main/SET_LOADING', true)
      try {
        const result = await this.$store.dispatch('schedule/sendApptCall', this.apptId)
        if (result.startsWith('OK')) {
          this.$modal.show('dialog', {
            title: 'WaitingMed',
            text: '<b>Call</b> successfully sent.'
          })
        } else {
          this.$modal.show('dialog', {
            title: 'WaitingMed',
            text: result
          })
        }
      } catch (error) {
        if (error.response.data.startsWith('ERROR')) {
          this.$modal.show('dialog', {
            title: 'WaitingMed',
            text: error.response.data
          })
        }

        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }
    async sendSMS() {
      this.$store.commit('main/SET_LOADING', true)
      try {
        const result: string = await this.$store.dispatch('schedule/sendApptSMS', this.apptId)
        if (result.startsWith('OK')) {
          var Jresult = JSON.parse(result.replace('OK:', ''))
          var text = '<b>' + Jresult['type'] + '</b> reminder successfully sent.'

          this.$modal.show('dialog', {
            title: 'WaitingMed',
            text: text
          })
        } else if (result.startsWith('ERROR')) {
          this.$modal.show('dialog', {
            title: 'WaitingMed',
            text: result
          })
        }
      } catch (error) {
        if (error.response.data.startsWith('ERROR')) {
          this.$modal.show('dialog', {
            title: 'WaitingMed',
            text: error.response.data
          })
        }
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }
    async save() {
      if (this.$v.appt.main!.$invalid) {
        this.$v.appt.main!.$touch()
        this.$modal.show('dialog', {
          title: 'WaitingMed',
          text: 'Main info is incorrect or incomplete.'
        })
        return
      }
      if (this.isServiceAppt) {
        // if (this.$v.appt.service!.description.$invalid) {
        //   this.$v.appt.service!.$touch();
        //   this.$modal.show("dialog", {
        //     title: "WaitingMed",
        //     text: "Service description is incorrect or incomplete.",
        //   });
        //   return;
        // }
        if (this.$v.appt.service!.address.$invalid) {
          this.$v.appt.service!.$touch()
          this.$modal.show('dialog', {
            title: 'WaitingMed',
            text: 'Service address is incorrect or incomplete.'
          })
          return
        }
      }

      if (this.appt.main.hasTeleconferencing) {
        if (!this.appt.main.patient.birth.date) {
          this.$v.appt.service!.$touch()
          this.$modal.show('dialog', {
            title: 'WaitingMed',
            text: 'Date of birth is required.'
          })
          return
        }
      }

      // CHECK PREREQS
      // const { prereqs } = this.appt;
      // for (let i = 0; i < prereqs.list.length; i++) {
      //   const req = prereqs.list[i];
      //   if (!req.optional && !(req.value || req.fileKey)) {
      //     this.$modal.show("dialog", {
      //       title: "WaitingMed",
      //       text: `Prerequisite '<span class='wm-fw-500'>${req.name}</span>' not met.`,
      //     });
      //     return;
      //   }
      // }
      //
      if (this.appt.recurrence?.enabled) {
        this.saveBulk()
        return
      }

      this.$store.commit('main/SET_LOADING', true)
      try {
        await this.$store.dispatch('schedule/saveAppt', this.appt)

        if (this.appt.main.officeCall) {
          const entry: GapLogEntry = {
            gapId: this.gapId,
            statusId: '',
            subStatusId: '',
            //reasonId: null,
            typeId: GapLogType.OFFICE_CALL,
            comment: ''
          }
          await this.$store.dispatch('gaps/saveLog', entry)
        }

        this.$emit('appt-saved')
        this.close()
      } catch (error) {
        console.log(error)
        //
        const err = error as any;
        const code = err?.response?.data?.Result;

        if (code === "SLOT_UNAVAILABLE") {
            Swal.fire({
    icon: 'warning',
    title: this.$t('Time Slot Unavailable').toString(),
    text: this.$t('Sorry, the selected appointment time is no longer available. Please select a different time slot or session.').toString(),
    confirmButtonText: this.$t('OK').toString()
});
    this.appt.main.time="";
    this.appt.main.sessionId="";
     this.getTimes();
     return;
        }




        //
         

      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }

    async saveBulk(createMode?: number, conflicts?: any[]) {
      this.$store.commit('main/SET_LOADING', true)

      try {
        let dates = this.generateRecurrenceList()

        // APPLY CHANGES FROM CONFLICT MODAL
        if (conflicts?.length) {
          dates = conflicts.map(x => ({
            date: moment(x.NewDate || x.Date).format('YYYY-MM-DD'),

            time: x.NewTime || x.Time
          }))
        }

        let result = await this.$store.dispatch('schedule/saveApptBulk', {
          baseAppt: this.appt,

          dates,

          createMode: createMode ?? 0
        })

        this.$store.commit('main/SET_LOADING', false)

        if (result.Failed > 0) {
          await this.showBulkAppointmentFailedResult(result)

          return
        }

        // ONLY SHOW CONFLICT MODAL DURING INITIAL VALIDATION
        if (result.RequiresConfirmation && createMode == null) {
          this.bulkConflictResult = result

          this.showConflictModal = true

          return
        }

        this.$emit('appt-saved')

        this.close()

        await this.showBulkAppointmentResult(result)
      } catch (error) {
        console.error('saveBulk()', error)

        this.$store.commit('main/SET_LOADING', false)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }

    async saveBulk20260608() {
      this.$store.commit('main/SET_LOADING', true)

      try {
        const dates = this.generateRecurrenceList()

        let result = await this.$store.dispatch('schedule/saveApptBulk', {
          baseAppt: this.appt,

          dates,

          createMode: 0
        })

        // ALWAYS STOP LOADING
        this.$store.commit('main/SET_LOADING', false)

        if (result.Failed > 0) {
          await this.showBulkAppointmentFailedResult(result)

          return
        }

        // CONFLICTS
        if (result.RequiresConfirmation) {
          const mode = await this.showBulkAppointmentConflicts(result)

          // CANCEL
          if (mode == null) {
            this.$store.commit('main/SET_LOADING', false)

            return
          }

          // START LOADING AGAIN
          this.$store.commit('main/SET_LOADING', true)

          result = await this.$store.dispatch('schedule/saveApptBulk', {
            baseAppt: this.appt,

            dates,

            createMode: mode
          })

          // STOP LOADING AFTER SAVE
          this.$store.commit('main/SET_LOADING', false)
        }

        this.$emit('appt-saved')

        this.close()

        await this.showBulkAppointmentResult(result)
      } catch (error) {
        console.error('saveBulk()', error)

        this.$store.commit('main/SET_LOADING', false)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }

    async saveBulkBK20260519() {
      this.$store.commit('main/SET_LOADING', true)
      try {
        const dates = this.generateRecurrenceList()

        var result = await this.$store.dispatch('schedule/saveApptBulk', {
          baseAppt: this.appt,
          dates: dates,
          createMode: 0
        })

        if (result['RequiresConfirmation']) {
          this.$store.commit('main/SET_LOADING', false)
          const mode = await this.showBulkAppointmentConflicts(result)

          if (mode == null) return

          this.$store.commit('main/SET_LOADING', true)
          result = await this.$store.dispatch('schedule/saveApptBulk', {
            baseAppt: this.appt,
            dates: dates,
            createMode: mode
          })

          this.$store.commit('main/SET_LOADING', false)

          this.showBulkAppointmentResult(result)

          this.$emit('appt-saved')
          this.close()
        } else {
          this.showBulkAppointmentResult(result)
          this.$store.commit('main/SET_LOADING', false)

          this.$emit('appt-saved')
          this.close()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }

    async showBulkAppointmentConflicts(result) {
      const invalidAppointments = result.Appointments.filter(x => !x.Available)

      const canCreateAll = this.$store.state.user?.settings?.ENABLE_UNLIMITED_APPOINTMENT_CREATION === true

      const html = `
        <div style="
            text-align:left;
            font-family:Arial,sans-serif;
            max-height:550px;
            overflow:auto;
            padding-right:6px;">

            <div style="
                background:#fff8e8;
                border:1px solid #ffe0a3;
                border-radius:20px;
                padding:20px;
                margin-bottom:20px;">

                <div style="
                    display:flex;
                    align-items:center;">

                    <div style="
                        width:60px;
                        height:60px;
                        border-radius:50%;
                        background:
                            rgba(27,172,190,.12);
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        margin-right:15px;">

                        <i
                            class="fas fa-exclamation-triangle"
                            style="
                                color:#1bacbe;
                                font-size:28px;">
                        </i>

                    </div>

                    <div>

                        <div style="
                            font-size:22px;
                            font-weight:700;
                            color:#111827;">

                            Appointment Conflicts

                        </div>

                        <div style="
                            color:#6b7280;
                            margin-top:4px;">

                            Some appointment slots
                            are no longer available.

                        </div>

                    </div>

                </div>

                <div style="
                    display:flex;
                    gap:15px;
                    margin-top:20px;">

                    <div style="
                        flex:1;
                        background:white;
                        border:1px solid #e5e7eb;
                        border-radius:16px;
                        padding:15px;">

                        <div style="
                            color:#16a34a;
                            font-size:14px;">

                            <i class="fas fa-calendar-check"></i>
                            Valid Slots

                        </div>

                        <div style="
                            font-size:34px;
                            font-weight:700;
                            color:#16a34a;">

                            ${result.ValidCount}

                        </div>

                    </div>

                    <div style="
                        flex:1;
                        background:white;
                        border:1px solid #e5e7eb;
                        border-radius:16px;
                        padding:15px;">

                        <div style="
                            color:#dc2626;
                            font-size:14px;">

                            <i class="fas fa-calendar-times"></i>
                            Conflicts

                        </div>

                        <div style="
                            font-size:34px;
                            font-weight:700;
                            color:#dc2626;">

                            ${result.InvalidCount}

                        </div>

                    </div>

                </div>

            </div>

            <div>

                <h3 style="
                    font-size:18px;
                    color:#111827;
                    margin-bottom:15px;">

                    <i class="fas fa-calendar-times"
                       style="color:#dc2626;">
                    </i>

                    Unavailable Slots

                </h3>

                ${invalidAppointments
                  .map(
                    slot => `

                    <div style="
                        background:white;
                        border-radius:18px;
                        padding:16px;
                        margin-bottom:12px;
                        border-left:5px solid #dc2626;
                        box-shadow:
                            0 2px 10px
                            rgba(0,0,0,.05);">

                        <div style="
                            display:flex;
                            justify-content:
                                space-between;
                            align-items:center;">

                            <div>

                                <div style="
                                    font-size:18px;
                                    font-weight:700;
                                    color:#111827;">

                                    <i
                                        class="fas fa-calendar-day"
                                        style="
                                            color:#1bacbe;">
                                    </i>

                                    ${moment(slot.Date).format('MM/DD/YYYY')}

                                </div>

                                <div style="
                                    margin-top:5px;
                                    color:#6b7280;">

                                    <i class="fas fa-clock"></i>

                                    ${moment(slot.Time, 'HH:mm:ss').format('hh:mm A')}

                                </div>

                            </div>

                            <span style="
                                background:#fee2e2;
                                color:#dc2626;
                                padding:8px 14px;
                                border-radius:999px;
                                font-size:12px;
                                font-weight:700;">

                                <i class="fas fa-times-circle"></i>
                                Unavailable

                            </span>

                        </div>

                        <div style="
                            margin-top:10px;
                            color:#6b7280;
                            font-size:13px;">

                            ${slot.Message}

                        </div>

                    </div>

                `
                  )
                  .join('')}

            </div>

            <div style="
                background:#f8fafc;
                border:1px solid #e5e7eb;
                border-radius:18px;
                padding:18px;
                margin-top:20px;">

                <div style="
                    font-size:17px;
                    font-weight:700;
                    color:#111827;
                    margin-bottom:10px;">

                    <i class="fas fa-question-circle"
                       style="color:#1bacbe;">
                    </i>

                    What would you like to do?

                </div>

                <div style="
                    color:#6b7280;
                    line-height:1.8;">

                    <div>
                        <b>Create Only Valid</b>
                        → Create only available appointments.
                    </div>

                    <div>
                        <b>Modify Conflicts</b>
                        → Edit unavailable appointments.
                    </div>

                    <div>
                        <b>Create All</b>
                        → Force creation of all appointments.
                    </div>

                    <div>
                        <b>Cancel</b>
                        → Do not create appointments.
                    </div>

                </div>

            </div>

        </div>
        `

      const swalResult = await Swal.fire({
        html,

        width: 900,

        showCancelButton: true,

        showDenyButton: true,

        showConfirmButton: true,

        confirmButtonText: '<i class="fas fa-layer-group"></i> Create All',

        denyButtonText: '<i class="fas fa-check-circle"></i> Create Only Valid',

        cancelButtonText: '<i class="fas fa-times"></i> Cancel',

        confirmButtonColor: '#f59e0b',

        denyButtonColor: '#1bacbe',

        reverseButtons: true,

        didOpen: () => {
          const actions = Swal.getActions()

          const modifyBtn = document.createElement('button')

          modifyBtn.innerHTML = '<i class="fas fa-edit"></i> Modify Conflicts'

          modifyBtn.className = 'swal2-styled'

          modifyBtn.style.background = '#1bacbe'

          modifyBtn.style.color = '#fff'

          modifyBtn.style.marginRight = '10px'

          modifyBtn.onclick = () => {
            Swal.close()

            this.bulkConflictResult = result

            this.showConflictModal = true
          }

          if (actions) {
            actions.insertBefore(modifyBtn, actions.firstChild)
          }

          const confirmBtn = Swal.getConfirmButton()

          if (confirmBtn && !canCreateAll) {
            confirmBtn.disabled = true

            confirmBtn.title = 'Permission required: Enable user to create unlimited appointments'

            confirmBtn.style.opacity = '0.5'

            confirmBtn.style.cursor = 'not-allowed'
          }
        }
      })

      if (swalResult.isConfirmed) {
        return 1
      }

      if (swalResult.isDenied) {
        return 2
      }

      return null
    }

    async showBulkAppointmentConflicts06052026(result) {
      const canCreateAll = this.$store.state.auth.user?.settings?.ENABLE_UNLIMITED_APPOINTMENT_CREATION

      const invalidAppointments = result.Appointments.filter(x => !x.Available)

      const html = `
        <div style="
            text-align:left;
            font-family:
                Arial,sans-serif;
            max-height:550px;
            overflow:auto;
            padding-right:6px;">

            <!-- HEADER CARD -->
            <div style="
                background:#fff8e8;
                border:1px solid #ffe0a3;
                border-radius:18px;
                padding:20px;
                margin-bottom:20px;
                box-shadow:
                    0 4px 12px
                    rgba(0,0,0,.05);">

                <div style="
                    display:flex;
                    align-items:center;">

                    <div style="
                        width:56px;
                        height:56px;
                        border-radius:50%;
                        background:
                            rgba(
                                27,
                                172,
                                190,
                                .12);
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        margin-right:15px;">

                        <i class="
                            fas fa-exclamation-triangle"
                            style="
                                color:#1bacbe;
                                font-size:24px;">
                        </i>

                    </div>

                    <div>

                        <div style="
                            font-size:22px;
                            font-weight:700;
                            color:#111827;">

                            Appointment Conflicts

                        </div>

                        <div style="
                            color:#6b7280;
                            margin-top:4px;
                            font-size:14px;">

                            Some appointment
                            slots are no longer
                            available.

                        </div>

                    </div>

                </div>

                <div style="
                    display:flex;
                    gap:12px;
                    margin-top:20px;">

                    <div style="
                        flex:1;
                        background:#fff;
                        border-radius:14px;
                        padding:14px;
                        border:1px solid
                            #eee;">

                        <div style="
                            color:#6b7280;
                            font-size:13px;">

                            <i class="
                                fas fa-calendar-check"
                                style="
                                    color:
                                    #16a34a;">
                            </i>

                            Valid Slots
                        </div>

                        <div style="
                            font-size:26px;
                            font-weight:700;
                            color:#16a34a;">

                            ${result.ValidCount}

                        </div>

                    </div>

                    <div style="
                        flex:1;
                        background:#fff;
                        border-radius:14px;
                        padding:14px;
                        border:1px solid
                            #eee;">

                        <div style="
                            color:#6b7280;
                            font-size:13px;">

                            <i class="
                                fas fa-calendar-times"
                                style="
                                    color:
                                    #dc2626;">
                            </i>

                            Conflicts
                        </div>

                        <div style="
                            font-size:26px;
                            font-weight:700;
                            color:#dc2626;">

                            ${result.InvalidCount}

                        </div>

                    </div>

                </div>
            </div>

            <!-- CONFLICT LIST -->
            <div style="
                margin-bottom:22px;">

                <h3 style="
                    margin:0 0 14px 0;
                    color:#111827;
                    font-size:18px;">

                    <i class="
                        fas fa-calendar-times"
                        style="
                            color:#dc2626;">
                    </i>

                    Unavailable Slots

                </h3>

                ${invalidAppointments
                  .map(
                    x => `
                        <div style="
                            background:#fff;
                            border-radius:14px;
                            padding:16px;
                            margin-bottom:12px;
                            border-left:
                                5px solid
                                #dc2626;
                            box-shadow:
                                0 2px 8px
                                rgba(
                                    0,
                                    0,
                                    0,
                                    .05);">

                            <div style="
                                display:flex;
                                justify-content:
                                    space-between;
                                align-items:center;">

                                <div>

                                    <div style="
                                        font-size:
                                            17px;
                                        font-weight:
                                            700;
                                        color:
                                            #111827;">

                                        <i class="
                                            fas fa-calendar-day"
                                            style="
                                                color:
                                                #1bacbe;">
                                        </i>

                                        ${moment(x.Date).format('MM/DD/YYYY')}

                                    </div>

                                    <div style="
                                        margin-top:
                                            6px;
                                        color:
                                            #6b7280;
                                        font-size:
                                            14px;">

                                        <i class="
                                            fas fa-clock">
                                        </i>

                                        ${moment(x.Time, 'HH:mm:ss').format('hh:mm A')}

                                    </div>

                                </div>

                                <span style="
                                    background:
                                        #fee2e2;
                                    color:
                                        #dc2626;
                                    padding:
                                        8px 14px;
                                    border-radius:
                                        999px;
                                    font-size:
                                        12px;
                                    font-weight:
                                        700;">

                                    <i class="
                                        fas fa-times-circle">
                                    </i>

                                    Unavailable

                                </span>

                            </div>

                            <div style="
                                margin-top:10px;
                                color:#6b7280;
                                font-size:13px;">

                                ${x.Message}

                            </div>

                        </div>
                    `
                  )
                  .join('')}

            </div>

            <!-- ACTIONS -->
            <div style="
                background:#f8fafc;
                border-radius:16px;
                padding:18px;
                border:1px solid
                    #e5e7eb;">

                <div style="
                    font-size:16px;
                    font-weight:700;
                    color:#111827;
                    margin-bottom:10px;">

                    <i class="
                        fas fa-question-circle"
                        style="
                            color:#1bacbe;">
                    </i>

                    What would you like to do?

                </div>

                <div style="
                    color:#6b7280;
                    font-size:14px;
                    line-height:1.7;">

                    <div>
                        <b>
                            Create All
                        </b>

                        → Create all
                        appointments
                        including
                        unavailable slots.
                    </div>

                    <div>
                        <b>
                            Create Only Valid
                        </b>

                        → Skip
                        unavailable
                        appointments and
                        create only valid
                        slots.
                    </div>

                    <div>
                        <b>
                            Cancel
                        </b>

                        → Do not create
                        appointments.
                    </div>

                </div>

            </div>

        </div>
        `

      const swalResult = await Swal.fire({
        title: '',

        html,

        showCancelButton: true,

        showDenyButton: true,

        confirmButtonText: canCreateAll
          ? '<i class="fas fa-layer-group"></i> Create All'
          : '<i class="fas fa-lock"></i> Create All',

        denyButtonText: '<i class="fas fa-check-circle"></i> Create Only Valid',

        cancelButtonText: '<i class="fas fa-times"></i> Cancel',

        confirmButtonColor: '#f59e0b',

        denyButtonColor: '#1bacbe',

        reverseButtons: true,

        width: 850,

        didOpen: () => {
          const confirmBtn = Swal.getConfirmButton()

          if (!canCreateAll && confirmBtn) {
            confirmBtn.disabled = true

            confirmBtn.style.opacity = '.5'

            confirmBtn.style.cursor = 'not-allowed'

            confirmBtn.title = 'You do not have permission to create unavailable appointments.'
          }
        }
      })

      // CREATE ALL
      if (swalResult.isConfirmed) {
        return 1
      }

      // CREATE ONLY VALID
      if (swalResult.isDenied) {
        return 2
      }

      // CANCEL
      return null
    }

    async showBulkAppointmentFailedResult(result) {
      const failedAppointments = result.Appointments.filter(x => !x.Created)

      const html = `
        <div style="
            text-align:left;
            font-family:
                Arial,sans-serif;
            max-height:600px;
            overflow:auto;
            padding-right:6px;">

            <!-- HEADER -->
            <div style="
                background:
                    linear-gradient(
                        135deg,
                        #fff5f5,
                        #fff
                    );
                border:
                    1px solid
                    #fecaca;
                border-radius:
                    20px;
                padding:
                    22px;
                margin-bottom:
                    20px;
                box-shadow:
                    0 4px 12px
                    rgba(
                        0,
                        0,
                        0,
                        .05);">

                <div style="
                    display:flex;
                    align-items:center;">

                    <div style="
                        width:64px;
                        height:64px;
                        border-radius:
                            50%;
                        background:
                            rgba(
                                220,
                                38,
                                38,
                                .1);
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        margin-right:
                            18px;">

                        <i class="
                            fas fa-times-circle"
                            style="
                                color:
                                    #dc2626;
                                font-size:
                                    30px;">
                        </i>

                    </div>

                    <div>

                        <div style="
                            font-size:
                                24px;
                            font-weight:
                                700;
                            color:
                                #111827;">

                            Multi Appointment Failed

                        </div>

                        <div style="
                            color:
                                #6b7280;
                            margin-top:
                                4px;
                            font-size:
                                14px;">

                            Some appointments
                            could not be created.

                        </div>

                    </div>

                </div>

                <!-- STATS -->
                <div style="
                    display:flex;
                    gap:12px;
                    margin-top:
                        20px;">

                    <div style="
                        flex:1;
                        background:#fff;
                        border-radius:
                            14px;
                        padding:14px;
                        border:
                            1px solid
                            #eee;">

                        <div style="
                            color:
                                #6b7280;
                            font-size:
                                13px;">

                            <i class="
                                fas fa-calendar"
                                style="
                                    color:
                                    #1bacbe;">
                            </i>

                            Total

                        </div>

                        <div style="
                            font-size:
                                28px;
                            font-weight:
                                700;
                            color:
                                #111827;">

                            ${result.Total}

                        </div>

                    </div>

                    <div style="
                        flex:1;
                        background:#fff;
                        border-radius:
                            14px;
                        padding:14px;
                        border:
                            1px solid
                            #eee;">

                        <div style="
                            color:
                                #6b7280;
                            font-size:
                                13px;">

                            <i class="
                                fas fa-times-circle"
                                style="
                                    color:
                                    #dc2626;">
                            </i>

                            Failed

                        </div>

                        <div style="
                            font-size:
                                28px;
                            font-weight:
                                700;
                            color:
                                #dc2626;">

                            ${result.Failed}

                        </div>

                    </div>

                </div>

                <!-- MULTI APPT ID -->
                <div style="
                    margin-top:
                        16px;
                    background:
                        #f8fafc;
                    border:
                        1px dashed
                        #cbd5e1;
                    border-radius:
                        14px;
                    padding:
                        12px;">

                    <div style="
                        font-size:
                            12px;
                        color:
                            #6b7280;
                        margin-bottom:
                            4px;">

                        Multi Appointment ID

                    </div>

                    <div style="
                        font-weight:
                            700;
                        color:
                            #1bacbe;
                        font-size:
                            15px;">

                        ${result.MultiApptID}

                    </div>

                </div>

            </div>

            <!-- FAILED APPOINTMENTS -->
            <div>

                <h3 style="
                    margin:0 0 14px 0;
                    color:#111827;
                    font-size:18px;">

                    <i class="
                        fas fa-exclamation-circle"
                        style="
                            color:#dc2626;">
                    </i>

                    Failed Appointments

                </h3>

                ${failedAppointments
                  .map(
                    x => `
                        <div style="
                            background:#fff;
                            border-radius:16px;
                            padding:16px;
                            margin-bottom:12px;
                            border-left:
                                5px solid
                                #dc2626;
                            box-shadow:
                                0 2px 8px
                                rgba(
                                    0,
                                    0,
                                    0,
                                    .05);">

                            <div style="
                                display:flex;
                                justify-content:
                                    space-between;
                                align-items:center;">

                                <div>

                                    <div style="
                                        font-size:
                                            17px;
                                        font-weight:
                                            700;
                                        color:
                                            #111827;">

                                        <i class="
                                            fas fa-calendar-day"
                                            style="
                                                color:
                                                #1bacbe;">
                                        </i>

                                        ${moment(x.Date).format('MM/DD/YYYY')}

                                    </div>

                                    <div style="
                                        margin-top:
                                            6px;
                                        color:
                                            #6b7280;
                                        font-size:
                                            14px;">

                                        <i class="
                                            fas fa-clock">
                                        </i>

                                        ${moment(x.Time, 'HH:mm:ss').format('hh:mm A')}

                                    </div>

                                </div>

                                <span style="
                                    background:
                                        #fee2e2;
                                    color:
                                        #dc2626;
                                    padding:
                                        8px 14px;
                                    border-radius:
                                        999px;
                                    font-size:
                                        12px;
                                    font-weight:
                                        700;">

                                    <i class="
                                        fas fa-times-circle">
                                    </i>

                                    Failed

                                </span>

                            </div>

                            <div style="
                                margin-top:
                                    12px;
                                background:
                                    #fff7ed;
                                border:
                                    1px solid
                                    #fed7aa;
                                border-radius:
                                    12px;
                                padding:
                                    12px;
                                color:
                                    #9a3412;
                                font-size:
                                    13px;
                                word-break:
                                    break-word;">

                                <i class="
                                    fas fa-bug">
                                </i>

                                ${x.Message}

                            </div>

                        </div>
                    `
                  )
                  .join('')}

            </div>

        </div>
        `

      await Swal.fire({
        title: '',

        html,

        icon: 'error',

        confirmButtonText: '<i class="fas fa-times"></i> Close',

        confirmButtonColor: '#1bacbe',

        width: 850
      })
    }

    async applyConflictChanges(conflicts: any[]) {
      await this.saveBulk(undefined, conflicts)
    }

    async showBulkAppointmentConflictsBK20260519(result) {
      //this.$store.commit("main/SET_LOADING", false);

      const invalidAppointments = result.Appointments.filter(x => !x.Available)

      const validAppointments = result.Appointments.filter(x => x.Available)

      const html = `
        <div style="
            text-align:left;
            font-family:
                Arial,sans-serif;
            max-height:550px;
            overflow:auto;
            padding-right:6px;">

            <!-- HEADER CARD -->
            <div style="
                background:#fff8e8;
                border:1px solid #ffe0a3;
                border-radius:18px;
                padding:20px;
                margin-bottom:20px;
                box-shadow:
                    0 4px 12px
                    rgba(0,0,0,.05);">

                <div style="
                    display:flex;
                    align-items:center;">

                    <div style="
                        width:56px;
                        height:56px;
                        border-radius:50%;
                        background:
                            rgba(
                                27,
                                172,
                                190,
                                .12);
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        margin-right:15px;">

                        <i class="
                            fas fa-exclamation-triangle"
                            style="
                                color:#1bacbe;
                                font-size:24px;">
                        </i>

                    </div>

                    <div>

                        <div style="
                            font-size:22px;
                            font-weight:700;
                            color:#111827;">

                            Appointment Conflicts

                        </div>

                        <div style="
                            color:#6b7280;
                            margin-top:4px;
                            font-size:14px;">

                            Some appointment
                            slots are no longer
                            available.

                        </div>

                    </div>

                </div>

                <div style="
                    display:flex;
                    gap:12px;
                    margin-top:20px;">

                    <div style="
                        flex:1;
                        background:#fff;
                        border-radius:14px;
                        padding:14px;
                        border:1px solid
                            #eee;">

                        <div style="
                            color:#6b7280;
                            font-size:13px;">

                            <i class="
                                fas fa-calendar-check"
                                style="
                                    color:
                                    #16a34a;">
                            </i>

                            Valid Slots
                        </div>

                        <div style="
                            font-size:26px;
                            font-weight:700;
                            color:#16a34a;">

                            ${result.ValidCount}

                        </div>

                    </div>

                    <div style="
                        flex:1;
                        background:#fff;
                        border-radius:14px;
                        padding:14px;
                        border:1px solid
                            #eee;">

                        <div style="
                            color:#6b7280;
                            font-size:13px;">

                            <i class="
                                fas fa-calendar-times"
                                style="
                                    color:
                                    #dc2626;">
                            </i>

                            Conflicts
                        </div>

                        <div style="
                            font-size:26px;
                            font-weight:700;
                            color:#dc2626;">

                            ${result.InvalidCount}

                        </div>

                    </div>

                </div>
            </div>

            <!-- CONFLICT LIST -->
            <div style="
                margin-bottom:22px;">

                <h3 style="
                    margin:0 0 14px 0;
                    color:#111827;
                    font-size:18px;">

                    <i class="
                        fas fa-calendar-times"
                        style="
                            color:#dc2626;">
                    </i>

                    Unavailable Slots

                </h3>

                ${invalidAppointments
                  .map(
                    x => `
                        <div style="
                            background:#fff;
                            border-radius:14px;
                            padding:16px;
                            margin-bottom:12px;
                            border-left:
                                5px solid
                                #dc2626;
                            box-shadow:
                                0 2px 8px
                                rgba(
                                    0,
                                    0,
                                    0,
                                    .05);">

                            <div style="
                                display:flex;
                                justify-content:
                                    space-between;
                                align-items:center;">

                                <div>

                                    <div style="
                                        font-size:
                                            17px;
                                        font-weight:
                                            700;
                                        color:
                                            #111827;">

                                        <i class="
                                            fas fa-calendar-day"
                                            style="
                                                color:
                                                #1bacbe;">
                                        </i>

                                        ${moment(x.Date).format('MM/DD/YYYY')}

                                    </div>

                                    <div style="
                                        margin-top:
                                            6px;
                                        color:
                                            #6b7280;
                                        font-size:
                                            14px;">

                                        <i class="
                                            fas fa-clock">
                                        </i>

                                        ${moment(x.Time, 'HH:mm:ss').format('hh:mm A')}

                                    </div>

                                </div>

                                <span style="
                                    background:
                                        #fee2e2;
                                    color:
                                        #dc2626;
                                    padding:
                                        8px 14px;
                                    border-radius:
                                        999px;
                                    font-size:
                                        12px;
                                    font-weight:
                                        700;">

                                    <i class="
                                        fas fa-times-circle">
                                    </i>

                                    Unavailable

                                </span>

                            </div>

                            <div style="
                                margin-top:10px;
                                color:#6b7280;
                                font-size:13px;">

                                ${x.Message}

                            </div>

                        </div>
                    `
                  )
                  .join('')}

            </div>

            <!-- ACTIONS -->
            <div style="
                background:#f8fafc;
                border-radius:16px;
                padding:18px;
                border:1px solid
                    #e5e7eb;">

                <div style="
                    font-size:16px;
                    font-weight:700;
                    color:#111827;
                    margin-bottom:10px;">

                    <i class="
                        fas fa-question-circle"
                        style="
                            color:#1bacbe;">
                    </i>

                    What would you like to do?

                </div>

                <div style="
                    color:#6b7280;
                    font-size:14px;
                    line-height:1.7;">

                    <div>
                        <b>
                            Create All
                        </b>

                        → Create all
                        appointments
                        including
                        unavailable slots.
                    </div>

                    <div>
                        <b>
                            Create Only Valid
                        </b>

                        → Skip
                        unavailable
                        appointments and
                        create only valid
                        slots.
                    </div>

                    <div>
                        <b>
                            Cancel
                        </b>

                        → Do not create
                        appointments.
                    </div>

                </div>

            </div>

        </div>
        `

      const swalResult = await Swal.fire({
        title: '',

        html,

        showCancelButton: true,

        showDenyButton: true,

        confirmButtonText: '<i class="fas fa-layer-group"></i> Create All',

        denyButtonText: '<i class="fas fa-check-circle"></i> Create Only Valid',

        cancelButtonText: '<i class="fas fa-times"></i> Cancel',

        confirmButtonColor: '#f59e0b',

        denyButtonColor: '#1bacbe',

        reverseButtons: true,

        width: 850
      })

      // CREATE ALL
      if (swalResult.isConfirmed) {
        return 1
      }

      // CREATE ONLY VALID
      if (swalResult.isDenied) {
        return 2
      }

      // CANCEL
      return null
    }

    async showBulkAppointmentConflictsBK(result) {
      const invalidAppointments = result.Appointments.filter(x => !x.Available)

      const html = `
        <div style="text-align:left">
            <p>
                <b>
                    ${result.InvalidCount}
                </b>
                appointment(s) are not available:
            </p>

            <ul style="
                max-height:250px;
                overflow:auto;
                padding-left:20px;
                margin-top:10px;">
                ${invalidAppointments
                  .map(
                    x => `
                            <li>
                                <b>
                                    ${moment(x.Date).format('MM/DD/YYYY')}
                                </b>
                                ${x.Time}
                                <br/>
                                <small>
                                    ${x.Message}
                                </small>
                            </li>
                        `
                  )
                  .join('')}
            </ul>

            <hr/>

            <p>
                What would you like to do?
            </p>

            <ul style="
                text-align:left;
                margin-top:10px;">
                <li>
                    <b>Create All</b>:
                    create all appointments
                </li>
                <li>
                    <b>Create Only Valid</b>:
                    skip unavailable slots
                </li>
                <li>
                    <b>Cancel</b>
                </li>
            </ul>
        </div>
        `

      const swalResult = await Swal.fire({
        title: 'Appointment Conflicts',
        html,
        icon: 'warning',

        showCancelButton: true,
        showDenyButton: true,

        confirmButtonText: 'Create All',

        denyButtonText: 'Create Only Valid',

        cancelButtonText: 'Cancel',

        confirmButtonColor: '#3085d6',

        denyButtonColor: '#28a745',

        reverseButtons: true,

        width: 700
      })

      // CREATE ALL
      if (swalResult.isConfirmed) {
        return 1
      }

      // CREATE ONLY VALID
      if (swalResult.isDenied) {
        return 2
      }

      // CANCEL
      return null
    }

    async createOnlyValidAppointments() {
      this.showConflictModal = false

      await this.saveBulkWithMode(1)
    }

    async createAllAppointments() {
      this.showConflictModal = false

      await this.saveBulkWithMode(2)
    }

    async saveBulkWithMode(createMode: number) {
      this.$store.commit('main/SET_LOADING', true)

      try {
        const dates = this.generateRecurrenceList()

        const result = await this.$store.dispatch('schedule/saveApptBulk', {
          baseAppt: this.appt,

          dates,

          createMode
        })

        this.$store.commit('main/SET_LOADING', false)

        this.$emit('appt-saved')

        this.close()

        await this.showBulkAppointmentResult(result)
      } catch (error) {
        console.error('saveBulkWithMode()', error)

        this.$store.commit('main/SET_LOADING', false)
      }
    }

    async saveNewLink(url: string) {
      if (!url) return
      const { apptId } = this
      const link = {
        apptId,
        id: null,
        url: url.toLowerCase(),
        description: ''
      }
      this.saveLink(link)
    }
    async saveLink(item) {
      try {
        const { apptId } = this
        const { id, url, description } = item
        await this.$store.dispatch('schedule/saveLink', {
          apptId,
          id,
          url,
          description
        })
        this.$bvToast.toast(`Link saved!`, {
          title: 'WaitingMed',
          toaster: 'b-toaster-top-right',
          autoHideDelay: 2000,
          solid: true
        })
        if (!item.id) this.getLinks()
      } catch (error) {
        console.log(error)
      }
    }
    async archiveLink(item) {
      this.$modal.show('dialog', {
        title: `Remove ${item.url}`,
        text: 'Are you sure?',
        buttons: [
          {
            title: 'Yes',
            handler: async () => {
              try {
                const { apptId } = this
                const { id } = item
                await this.$store.dispatch('schedule/archiveLink', {
                  apptId,
                  id
                })
                this.$bvToast.toast(`Link archived!`, {
                  title: 'WaitingMed',
                  toaster: 'b-toaster-top-right',
                  autoHideDelay: 2000,
                  solid: true
                })
                this.getLinks()
                this.$modal.hide('dialog')
              } catch (error) {
                console.log(error)
              }
            }
          },
          {
            title: 'No',
            default: true
          }
        ]
      })
    }

    async showBulkAppointmentResult(result) {
      const createdAppointments = result.Appointments?.filter(x => x.Created && x.Result?.appt) ?? []

      if (!createdAppointments.length) {
        return
      }

      const firstAppt = createdAppointments[0].Result.appt

      const html = `
        <div style="
            text-align:left;
            font-family:Arial,sans-serif;
            max-height:550px;
            overflow:auto;
            padding-right:6px;">

            <!-- PATIENT CARD -->
            <div style="
                background:#ffffff;
                border-radius:16px;
                padding:18px;
                margin-bottom:20px;
                border:1px solid #e9ecef;
                box-shadow:
                    0 2px 10px
                    rgba(0,0,0,.06);">

                <div style="
                    display:flex;
                    align-items:center;
                    margin-bottom:15px;">

                    <div style="
                        width:48px;
                        height:48px;
                        border-radius:50%;
                        background:#eef4ff;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        margin-right:12px;">

                        <i class="
                            fas fa-user-injured"
                            style="
                                color:#1bacbe;
                                font-size:20px;">
                        </i>
                    </div>

                    <div>
                        <div style="
                            font-size:18px;
                            font-weight:700;
                            color:#1f2937;">
                            Patient Information
                        </div>

                        <div style="
                            font-size:13px;
                            color:#6b7280;">
                            Appointment batch created successfully
                        </div>
                    </div>
                </div>

                <div style="
                    display:grid;
                    grid-template-columns:
                        1fr 1fr;
                    gap:12px;">

                    <div>
                        <div style="
                            color:#6b7280;
                            font-size:12px;">
                            <i class="fas fa-user"></i>
                            Patient
                        </div>

                        <div style="
                            font-weight:600;
                            color:#111827;">
                            ${firstAppt.firstName ?? ''}
                            ${firstAppt.lastName ?? ''}
                        </div>
                    </div>

                    <div>
                        <div style="
                            color:#6b7280;
                            font-size:12px;">
                            <i class="fas fa-phone"></i>
                            Phone
                        </div>

                        <div style="
                            font-weight:600;
                            color:#111827;">
                            ${firstAppt.phone ?? '-'}
                        </div>
                    </div>

                    <div>
                        <div style="
                            color:#6b7280;
                            font-size:12px;">
                            <i class="
                                fas fa-user-md">
                            </i>
                            Calendar
                        </div>

                        <div style="
                            font-weight:600;
                            color:#111827;">
                            ${firstAppt.calendarName ?? '-'}
                        </div>
                    </div>

                    <div>
                        <div style="
                            color:#6b7280;
                            font-size:12px;">
                            <i class="
                                fas fa-stethoscope">
                            </i>
                            Reason
                        </div>

                        <div style="
                            font-weight:600;
                            color:#111827;">
                            ${firstAppt.reasonName ?? '-'}
                        </div>
                    </div>

                </div>

                <div style="
                    margin-top:18px;
                    background:#f9fafb;
                    border-radius:12px;
                    padding:12px;
                    border:1px dashed #d1d5db;">

                    <div style="
                        font-size:12px;
                        color:#6b7280;
                        margin-bottom:4px;">

                        <i class="
                            fas fa-layer-group">
                        </i>
                        Multi Appointment ID
                    </div>

                    <div style="
                        font-weight:700;
                        color:#1bacbe;
                        word-break:break-word;">
                        ${result.MultiApptID ?? '-'}
                    </div>

                </div>
            </div>

            <!-- APPOINTMENTS -->
            <div style="
                margin-bottom:20px;">

                <div style="
                    display:flex;
                    justify-content:
                        space-between;
                    align-items:center;
                    margin-bottom:14px;">

                    <h3 style="
                        margin:0;
                        color:#111827;
                        font-size:20px;">

                        <i class="
                            fas fa-calendar-check"
                            style="
                                color:#22c55e;">
                        </i>

                        Appointments Created
                    </h3>

                    <span style="
                        background:#dcfce7;
                        color:#15803d;
                        padding:6px 12px;
                        border-radius:999px;
                        font-size:13px;
                        font-weight:700;">

                        ${result.Created}
                        Created
                    </span>
                </div>

                ${createdAppointments
                  .map(x => {
                    const appt = x.Result.appt

                    return `
                            <div style="
                                background:#fff;
                                border-radius:14px;
                                padding:16px;
                                margin-bottom:12px;
                                border:1px solid #ececec;
                                box-shadow:
                                    0 2px 8px
                                    rgba(
                                        0,
                                        0,
                                        0,
                                        .05);">

                                <div style="
                                    display:flex;
                                    justify-content:
                                        space-between;
                                    align-items:
                                        center;">

                                    <div>

                                        <div style="
                                            font-size:17px;
                                            font-weight:
                                                700;
                                            color:
                                                #111827;">

                                            <i class="
                                                fas fa-calendar-day"
                                                style="
                                                    color:
                                                    #1bacbe;">
                                            </i>

                                            ${moment(appt.date).format('MM/DD/YYYY')}

                                        </div>

                                        <div style="
                                            margin-top:
                                                6px;
                                            color:
                                                #6b7280;
                                            font-size:
                                                14px;">

                                            <i class="
                                                fas fa-clock">
                                            </i>

                                            ${moment(appt.time, 'HH:mm:ss').format('hh:mm A')}
                                        </div>

                                    </div>

                                    <span style="
                                        background:
                                            #dcfce7;
                                        color:
                                            #15803d;
                                        padding:
                                            8px 14px;
                                        border-radius:
                                            999px;
                                        font-size:
                                            12px;
                                        font-weight:
                                            700;">

                                        <i class="
                                            fas fa-check-circle">
                                        </i>

                                        ${appt.statusName}

                                    </span>

                                </div>

                            </div>
                        `
                  })
                  .join('')}

            </div>

            <!-- FOOTER -->
            <div style="
                border-top:
                    1px solid
                    #e5e7eb;
                padding-top:14px;
                display:flex;
                justify-content:
                    space-between;
                color:#6b7280;
                font-size:14px;">

                <div>
                    <i class="
                        fas fa-check-circle"
                        style="
                            color:#22c55e;">
                    </i>

                    Total Created:
                    <b>
                        ${result.Created}
                    </b>
                </div>

                <div>
                    <i class="
                        fas fa-layer-group">
                    </i>

                    Batch:
                    <b>
                        ${result.MultiApptID}
                    </b>
                </div>

            </div>

        </div>
        `

      await Swal.fire({
        title: 'Appointments Created',

        html,

        icon: 'success',

        width: 850,

        confirmButtonText: '<i class="fas fa-check"></i> OK,Got it!',

        confirmButtonColor: '#1bacbe'
      })
    }

    async showBulkAppointmentResultBK(result) {
      const createdAppointments = result.Appointments?.filter(x => x.Created && x.Result?.appt) ?? []

      if (!createdAppointments.length) {
        return
      }

      const firstAppt = createdAppointments[0].Result.appt

      const html = `
        <div style="
            text-align:left;
            max-height:450px;
            overflow:auto;">

            <div style="
                background:#f8f9fa;
                border-radius:8px;
                padding:12px;
                margin-bottom:15px;">

                <h4 style="
                    margin:0 0 10px 0;">
                    Patient Information
                </h4>

                <div>
                    <b>Name:</b>
                    ${firstAppt.firstName ?? ''}
                    ${firstAppt.lastName ?? ''}
                </div>

                <div>
                    <b>Phone:</b>
                    ${firstAppt.phone ?? '-'}
                </div>

                <div>
                    <b>Calendar:</b>
                    ${firstAppt.calendarName ?? '-'}
                </div>

                <div>
                    <b>Reason:</b>
                    ${firstAppt.reasonName ?? '-'}
                </div>

                <div>
                    <b>Multi Appointment ID:</b>
                    ${result.MultiApptID ?? '-'}
                </div>
            </div>

            <div>

                <h4>
                    Appointments Created
                    (${result.Created})
                </h4>

                <ul style="
                    padding-left:20px;">

                    ${createdAppointments
                      .map(x => {
                        const appt = x.Result.appt

                        return `
                                    <li style="
                                        margin-bottom:10px;">

                                        <b>
                                            ${moment(appt.date).format('MM/DD/YYYY')}
                                        </b>

                                        at

                                        <b>
                                            ${appt.time}
                                        </b>

                                        <br/>

                                        <small>
                                            ${appt.statusName}
                                        </small>

                                    </li>
                                `
                      })
                      .join('')}

                </ul>

            </div>

            <hr/>

            <div style="
                font-size:13px;
                color:#666;">

                <b>Total Created:</b>
                ${result.Created}

            </div>

        </div>
        `

      await Swal.fire({
        title: 'Appointments Created',
        html,
        icon: 'success',
        width: 700,
        confirmButtonText: 'OK'
      })
    }
    async showForm(prereq: any, wizard: boolean) {
      await this.setForm(prereq)
      if (wizard) {
        this.$modal.show('form-wizard')
      } else {
        this.$modal.show('form-viewer')
      }
    }
    async setForm(prereq: any) {
      this.prereqForm.form = {
        id: prereq.formId,
        name: prereq.name,
        hasAnswers: false
      }
      this.$store.commit('main/SET_LOADING', true)
      try {
        const { id } = this.appt
        const { formId } = prereq
        this.prereqForm.questions = await this.$store.dispatch('schedule/getApptFormQuestions', {
          id,
          formId
        })

        //set default values
        this.prereqForm.questions.forEach(q => {
          if (!q.answer.value && q.options && q.options.apptField) {
            const { apptField } = q.options
            const { answer } = q
            switch (apptField) {
              case 'APPT_ID':
                answer.value = this.appt.id
                break
              case 'APPT_PROVIDER':
                answer.value = this.calendars.find(c => c.id == this.appt.main.calendarId)?.name
                break
              case 'APPT_STATUS':
                answer.value = this.status.find(s => s.id == this.appt.main.statusId)?.name
                break
              case 'APPT_DATE':
                answer.value = this.appt.main.date
                break
              case 'APPT_TIME':
                answer.value = this.appt.main.time
                break
              case 'APPT_REF':
                answer.value = this.appt.main.reference
                break
              case 'APPT_REASON':
                answer.value = this.reasons.find(r => r.id == this.appt.main.reasonId)?.name
                break
              case 'APPT_RECORD_DATE':
                answer.value = moment(this.appt.recordDate).format('MMM DD, YYYY')
                break
              case 'APPT_RECORD_TIME':
                answer.value = moment(this.appt.recordDate).format('HH:mm:ss')
                break
              case 'APPT_RECORD_DATE_TIME':
                answer.value = JSON.stringify({
                  date: this.appt.recordDate,
                  time: moment(this.appt.recordDate).format('HH:mm:ss')
                })
                break
              // PATIENT
              case 'PATIENT_ID':
                answer.value = this.appt.main.patient.id
                break
              case 'PATIENT_FIRST_NAME':
                answer.value = this.appt.main.patient.firstName
                break
              case 'PATIENT_LAST_NAME':
                answer.value = this.appt.main.patient.lastName
                break
              case 'PATIENT_LAST_NAME_2':
                answer.value = this.appt.main.patient.lastName2 ? this.appt.main.patient.lastName2 : ''
                break
              case 'PATIENT_FULL_NAME':
                answer.value = this.appt.main.patient.lastName + ', ' + this.appt.main.patient.firstName
                break
              /*case "PATIENT_GENDER":
                          answer.value = this.appt.main.patient.gender;
                          break;*/
              case 'PATIENT_BIRTHDATE':
                answer.value = this.appt.main.patient.birth.date
                break
              case 'PATIENT_INSURER':
                answer.value = this.insurers.find(i => i.id === this.appt.main.patient.insurer.id)?.name
                break
              case 'PATIENT_MEMBER_ID':
                answer.value = this.appt.main.patient.insurer.memberId
                break
              case 'PATIENT_EMAIL':
                answer.value = this.appt.main.patient.email
                break
              case 'PATIENT_PHONE':
                answer.value = this.appt.main.patient.phone
                break

              //
            }
          }
        })

        //
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }

    async getFormQuestions(prereq: any) {
      this.$store.commit('main/SET_LOADING', true)
      try {
        const { id } = this.appt
        const { formId } = prereq
        const questions: FormQuestion[] = await this.$store.dispatch('schedule/getApptFormQuestions', {
          id,
          formId
        })

        //set default values
        questions.forEach(q => {
          if (!q.answer.value && q.options && q.options.apptField) {
            const { apptField } = q.options
            const { answer } = q
            switch (apptField) {
              case 'APPT_ID':
                answer.value = this.appt.id
                break
              case 'APPT_PROVIDER':
                answer.value = this.calendars.find(c => c.id == this.appt.main.calendarId)?.name
                break
              case 'APPT_STATUS':
                answer.value = this.status.find(s => s.id == this.appt.main.statusId)?.name
                break
              case 'APPT_DATE':
                answer.value = this.appt.main.date
                break
              case 'APPT_TIME':
                answer.value = this.appt.main.time
                break
              case 'APPT_REF':
                answer.value = this.appt.main.reference
                break
              case 'APPT_REASON':
                answer.value = this.reasons.find(r => r.id == this.appt.main.reasonId)?.name
                break
              case 'APPT_RECORD_DATE':
                answer.value = moment(this.appt.recordDate).format('MMM DD, YYYY')
                break
              case 'APPT_RECORD_TIME':
                answer.value = moment(this.appt.recordDate).format('HH:mm:ss')
                break
              case 'APPT_RECORD_DATE_TIME':
                answer.value = JSON.stringify({
                  date: this.appt.recordDate,
                  time: moment(this.appt.recordDate).format('HH:mm:ss')
                })
                break
              // PATIENT
              case 'PATIENT_ID':
                answer.value = this.appt.main.patient.id
                break
              case 'PATIENT_FIRST_NAME':
                answer.value = this.appt.main.patient.firstName
                break
              case 'PATIENT_LAST_NAME':
                answer.value = this.appt.main.patient.lastName
                break
              case 'PATIENT_LAST_NAME_2':
                answer.value = this.appt.main.patient.lastName2 ? this.appt.main.patient.lastName2 : ''
                break
              case 'PATIENT_FULL_NAME':
                answer.value = this.appt.main.patient.lastName + ', ' + this.appt.main.patient.firstName
                break
              /*case "PATIENT_GENDER":
                          answer.value = this.appt.main.patient.gender;
                          break;*/
              case 'PATIENT_BIRTHDATE':
                answer.value = this.appt.main.patient.birth.date
                break
              case 'PATIENT_INSURER':
                answer.value = this.insurers.find(i => i.id === this.appt.main.patient.insurer.id)?.name
                break
              case 'PATIENT_MEMBER_ID':
                answer.value = this.appt.main.patient.insurer.memberId
                break
              case 'PATIENT_EMAIL':
                answer.value = this.appt.main.patient.email
                break
              case 'PATIENT_PHONE':
                answer.value = this.appt.main.patient.phone
                break

              //
            }
          }
        })
        return questions
        //
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }
    async openForm(prereq: any, wizard: boolean) {
      this.prereqForm.form = {
        id: prereq.formId,
        name: prereq.name,
        hasAnswers: false
      }
      this.$store.commit('main/SET_LOADING', true)
      try {
        const { id } = this.appt
        const { formId } = prereq
        this.prereqForm.questions = await this.$store.dispatch('schedule/getApptFormQuestions', {
          id,
          formId
        })

        //set default values
        this.prereqForm.questions.forEach(q => {
          if (!q.answer.value && q.options && q.options.apptField) {
            const { apptField } = q.options
            const { answer } = q
            switch (apptField) {
              case 'APPT_ID':
                answer.value = this.appt.id
                break
              case 'APPT_PROVIDER':
                answer.value = this.calendars.find(c => c.id == this.appt.main.calendarId)?.name
                break
              case 'APPT_STATUS':
                answer.value = this.status.find(s => s.id == this.appt.main.statusId)?.name
                break
              case 'APPT_DATE':
                answer.value = this.appt.main.date
                break
              case 'APPT_TIME':
                answer.value = this.appt.main.time
                break
              case 'APPT_REF':
                answer.value = this.appt.main.reference
                break
              case 'APPT_REASON':
                answer.value = this.reasons.find(r => r.id == this.appt.main.reasonId)?.name
                break
              case 'APPT_RECORD_DATE':
                answer.value = moment(this.appt.recordDate).format('MMM DD, YYYY')
                break
              case 'APPT_RECORD_TIME':
                answer.value = moment(this.appt.recordDate).format('HH:mm:ss')
                break
              case 'APPT_RECORD_DATE_TIME':
                answer.value = JSON.stringify({
                  date: this.appt.recordDate,
                  time: moment(this.appt.recordDate).format('HH:mm:ss')
                })
                break
              // PATIENT
              case 'PATIENT_ID':
                answer.value = this.appt.main.patient.id
                break
              case 'PATIENT_FIRST_NAME':
                answer.value = this.appt.main.patient.firstName
                break
              case 'PATIENT_LAST_NAME':
                answer.value = this.appt.main.patient.lastName
                break
              case 'PATIENT_LAST_NAME_2':
                answer.value = this.appt.main.patient.lastName2 ? this.appt.main.patient.lastName2 : ''
                break
              case 'PATIENT_FULL_NAME':
                answer.value = this.appt.main.patient.lastName + ', ' + this.appt.main.patient.firstName
                break
              /*case "PATIENT_GENDER":
                          answer.value = this.appt.main.patient.gender;
                          break;*/
              case 'PATIENT_BIRTHDATE':
                answer.value = this.appt.main.patient.birth.date
                break
              case 'PATIENT_INSURER':
                answer.value = this.insurers.find(i => i.id === this.appt.main.patient.insurer.id)?.name
                break
              case 'PATIENT_MEMBER_ID':
                answer.value = this.appt.main.patient.insurer.memberId
                break
              case 'PATIENT_EMAIL':
                answer.value = this.appt.main.patient.email
                break
              case 'PATIENT_PHONE':
                answer.value = this.appt.main.patient.phone
                break

              //
            }
          }
        })

        //
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
      if (wizard == undefined) {
        return
      }
      if (wizard) {
        this.$modal.show('form-wizard')
      } else {
        this.$modal.show('form-viewer')
      }
    }
    async saveFormAnswers(answers) {
      this.$store.commit('main/SET_LOADING', true)
      try {
        const { id } = this.appt
        const formId = this.prereqForm.form.id
        await this.$store.dispatch('schedule/saveApptFormAnswers', {
          id,
          formId,
          answers
        })
        //this.getAppt();
        this.getPreReqs()
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }
    async close() {
      this.$modal.hide('appt-editor')
    }

    async archiveAppt() {
      if (this.appt.main.archived) {
        var time = this.calendar.times.filter(t => t.time == this.appt.main.time)[0]
        if (!time || time['disabled']) {
          this.$modal.show('dialog', {
            title: 'WaitingMed',
            text: 'Time not available.'
          })
          return
        }
      }

      this.$modal.show('dialog', {
        title: `${this.appt.main.archived ? 'Unarchive' : 'Archive'} Appt #${this.appt.id}`,
        text: 'Are you sure?',
        buttons: [
          {
            title: 'Yes',
            handler: async () => {
              this.appt.main.archived = !this.appt.main.archived
              this.save()
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'No',
            default: true
          }
        ]
      })
    }

    get isServiceAppt() {
      if (!this.appt.main.typeId) {
        return false
      }
      return this.appt.main.typeId !== ScheduleType.REGULAR
    }
    get fileInput(): HTMLInputElement {
      return document.getElementById('fileInput') as HTMLInputElement
    }
    get prereqFileInput(): HTMLInputElement {
      return document.getElementById('prereqFileInput') as HTMLInputElement
    }
    get status() {
      return this.typeStatus.filter(s => s.apptTypeId === this.appt.main.typeId)
    }
    get ScheduleType() {
      return ScheduleType
    }
    get ScheduleSession() {
      return ScheduleSession
    }
    get SchedulePreReqType() {
      return SchedulePreReqType
    }
    get scheduleTypeName() {
      switch (this.appt.main.typeId) {
        case ScheduleType.REGULAR:
          return 'Appointment'
        case ScheduleType.DELIVERY:
          return 'Delivery'
        case ScheduleType.READY_RESPONDERS:
          return '3-Way Home Service Appt.'
        case ScheduleType.SERVICE:
          return 'Service'
        default:
          return ''
      }
    }
    get fileIcon() {
      return fileIcon
    }
    get fileSize() {
      return fileSize
    }

    async exportPDFx(data) {
      //var questions = Array<FormQuestion> await this.getFormQuestions(data);
      const questions: FormQuestion[] = (await this.getFormQuestions(data)) || []

      const form = {
        id: data.formId,
        name: data.name,
        hasAnswers: false
      }

      const patient = this.appt.main.patient
      const formData = { form, questions, patient } as { form: Form; questions: Array<FormQuestion>; patient: any }

      //console.log(questions);

      //this.$store.commit("main/SET_LOADING", true);

      //this.$root.$emit('export-pdf',form,questions);
      this.$root.$emit('export-pdf', formData)
    }

    async generateFormPdf(form) {
      await this.setForm(form)
      await this.$nextTick()

      // Esperar un poco a que Vue pinte el DOM completamente
      await new Promise(resolve => setTimeout(resolve, 300))

      const element = document.getElementById('pdf-form-viewer')
      if (!element) {
        console.error('No se encontró el elemento PDF en el DOM.')
        return
      }

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false
      })

      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF('p', 'mm', 'a4')

      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width

      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight)
      pdf.save(`${form.name || 'formulario'}.pdf`)
    }

    async generateFormPdfBK(form) {
      await this.setForm(form)

      const element = document.getElementById('pdf-form-viewer')
      if (!element) return

      element.style.display = 'block'

      const canvas = await html2canvas(element, { scale: 2 })
      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF('p', 'mm', 'a4')

      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width

      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight)
      pdf.save(`${form.name || 'formulario'}.pdf`)

      element.style.display = 'none'
    }

    async exportPDF(prereq: any) {
      this.$store.commit('main/SET_LOADING', true)
      try {
        const { id } = this.appt
        const { formId, name } = prereq

        const data = await this.$store.dispatch('schedule/getApptFormPdf', {
          id,
          formId
        })
        const blob = new Blob([data], { type: 'application/pdf' })
        const anchor = document.createElement('a')
        const timestamp = this.$moment().format('YYMMDD_HHmmss')
        anchor.download = `${name}_${timestamp}.pdf`
        anchor.href = window.URL.createObjectURL(blob)
        anchor.dataset.downloadurl = ['application/pdf', anchor.download, anchor.href].join(':')
        anchor.click()
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }

    mounted() {
      if (this.apptId) {
        this.getAppt()
      } else {
        const defaultCalendar = this.calendars.find(c => c.isDefault)
        if (defaultCalendar) {
          this.appt.main.calendarId = defaultCalendar.id
          this.appt.main.lang = defaultCalendar.lang
        }
        if (this.patientId) {
          this.getPatient()
        }
        if (this.patientName) {
          if (this.patientName.includes(' ')) {
            const arr = this.patientName.split(' ')
            this.appt.main.patient.firstName = arr[0]
            this.appt.main.patient.lastName = arr[arr.length - 1]
          } else {
            this.appt.main.patient.firstName = this.patientName
          }
        }
        if (this.patientPhone) {
          this.appt.main.patient.phone = this.patientPhone
        }
        if (this.transportation != null) {
          this.appt.main.transportation = this.transportation
        }
        if (this.officeCall) {
          this.appt.main.officeCall = this.officeCall
        }
      }
      this.getTimes()
      this.getInsurers()
      this.setBirthYears()
    }
  }
